import React, { useState, useEffect } from "react";

import { Row, Col, Input, Pagination } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

const categoryBtnTablet = {
  fontSize: ".8em",
  fontFamily: "IRANSans",
  width: "100px",
  textAlign: "center",
};
const categoryBtnMobile = {
  fontSize: ".7em",
  fontFamily: "IRANSans",
  width: "125px",
  textAlign: "center",
};

const ArticlesCategory = (props) => {
  const [category, setCategory] = useState(null);

  useEffect(() => {
    setCategory(props.category);
  });

  const active = {
    textDecoration: "none",
    display: "inline-block",
    borderRadius: "100px",
    padding: "5.5px 10px",
    transition: "all .2s",
    position: "relative",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    color: "#fff",
    backgroundColor: "#186491",
    fontSize: ".9em",
    fontFamily: "IRANSans",
    width: "150px",
    textAlign: "center",
  };
  const deactive = {
    textDecoration: "none",
    display: "inline-block",
    borderRadius: "100px",
    padding: "5.5px 10px",
    transition: "all .2s",
    position: "relative",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    color: "#186491",
    backgroundColor: "#fff",
    fontSize: ".9em",
    fontFamily: "IRANSans",
    width: "150px",
    textAlign: "center",
  };
  const activeTablet = {
    textDecoration: "none",
    display: "inline-block",
    borderRadius: "100px",
    padding: "5.5px 10px",
    transition: "all .2s",
    position: "relative",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    color: "#fff",
    backgroundColor: "#186491",
    fontSize: ".8em",
    fontFamily: "IRANSans",
    width: "125px",
    textAlign: "center",
  };
  const deactiveTablet = {
    textDecoration: "none",
    display: "inline-block",
    borderRadius: "100px",
    padding: "5.5px 10px",
    transition: "all .2s",
    position: "relative",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    color: "#186491",
    backgroundColor: "#fff",
    fontSize: ".8em",
    fontFamily: "IRANSans",
    width: "125px",
    textAlign: "center",
  };
  const activeMobile = {
    textDecoration: "none",
    display: "inline-block",
    borderRadius: "100px",
    padding: "5.5px 10px",
    transition: "all .2s",
    position: "relative",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    color: "#fff",
    backgroundColor: "#186491",
    fontSize: ".8em",
    fontFamily: "IRANSans",
    width: "150px",
    textAlign: "center",
  };
  const deactiveMobile = {
    textDecoration: "none",
    display: "inline-block",
    borderRadius: "100px",
    padding: "5.5px 10px",
    transition: "all .2s",
    position: "relative",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    color: "#186491",
    backgroundColor: "#fff",
    fontSize: ".8em",
    fontFamily: "IRANSans",
    width: "150px",
    textAlign: "center",
  };
  return props.size === "laptopdesktop" ? (
    <div>
      <Center>
        <a
          href
          style={category === "bime" ? active : deactive}
          onClick={() => props.set_type("bime")}
        >
          مقالات بیمه ای
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          href
          onClick={() => props.set_type("law")}
          style={category === "law" ? active : deactive}
        >
          مقالات حقوقی
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("it")}
          style={category === "it" ? active : deactive}
        >
          IT مقالات
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("bank")}
          style={category === "bank" ? active : deactive}
        >
          مقالات بانکی
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("translate")}
          style={category === "translate" ? active : deactive}
        >
          مقالات ترجمه شده
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("more")}
          style={category === "more" ? active : deactive}
        >
          سایر مقالات
        </a>
      </Center>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Center>
        <a
          href
          style={category === "bime" ? activeTablet : deactiveTablet}
          onClick={() => props.set_type("bime")}
        >
          مقالات بیمه ای
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          href
          onClick={() => props.set_type("law")}
          style={category === "law" ? activeTablet : deactiveTablet}
        >
          مقالات حقوقی
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("it")}
          style={category === "it" ? activeTablet : deactiveTablet}
        >
          IT مقالات
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("bank")}
          style={category === "bank" ? activeTablet : deactiveTablet}
        >
          مقالات بانکی
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("translate")}
          style={category === "translate" ? activeTablet : deactiveTablet}
        >
          مقالات ترجمه شده
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("more")}
          style={category === "more" ? activeTablet : deactiveTablet}
        >
          سایر مقالات
        </a>
      </Center>
    </div>
  ) : (
    <div>
      <Center>
        <a
          href
          style={category === "bime" ? activeMobile : deactiveMobile}
          onClick={() => props.set_type("bime")}
        >
          مقالات بیمه ای
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          href
          onClick={() => props.set_type("law")}
          style={category === "law" ? activeMobile : deactiveMobile}
        >
          مقالات حقوقی
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("it")}
          style={category === "it" ? activeMobile : deactiveMobile}
        >
          IT مقالات
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("bank")}
          style={category === "bank" ? activeMobile : deactiveMobile}
        >
          مقالات بانکی
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("translate")}
          style={category === "translate" ? activeMobile : deactiveMobile}
        >
          مقالات ترجمه شده
        </a>
      </Center>
      <Margin top={3}></Margin>
      <Center>
        <a
          onClick={() => props.set_type("more")}
          style={category === "more" ? activeMobile : deactiveMobile}
        >
          سایر مقالات
        </a>
      </Center>
    </div>
  );
};

export default ArticlesCategory;
